import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { EuTaxonomyMobileNav } from '@/features/eu-taxonomy/components/EuTaxonomyMobileNav';
import { EuTaxonomyNav } from '@/features/eu-taxonomy/components/EuTaxonomyNav';

export const Route = createFileRoute('/_authenticated/eu-taxonomy')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/eu-taxonomy') {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/eu-taxonomy/overview' });
    }

    return {
      getTitle: () => 'EU Taxonomy',
    };
  },
  component: EuTaxonomyLayout,
});

function EuTaxonomyLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-[calc(100vh-4rem)]">
      <EuTaxonomyNav />
      <EuTaxonomyMobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

      <div className="flex-1 overflow-auto">
        <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setMobileNavOpen(true);
            }}
            aria-label="EU Taxonomy navigation"
            className="h-11 w-11"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="ml-2 text-sm font-medium text-muted-foreground">EU Taxonomy</span>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
